import Api from 'src/api/API';

export default {
    Index() {
        return Api.get('/Auth/Health/GuideSurvey');
    },
    FindByUser(UserID) {
        return Api.get('/Auth/Health/GuideSurvey/User/'+UserID);
    },
    Add(data) {
        return Api.post('/Auth/Health/GuideSurvey', data);
    },
    Update(SurveyID, data) {
        return Api.patch('/Auth/Health/GuideSurvey/'+SurveyID, data);
    },
    Delete(SurveyID) {
        return Api.delete('/Auth/Health/GuideSurvey/'+SurveyID);
    },

    getObjectives() {
        return Api.get('/Auth/Health/GuideSurvey/Objectives')
    }
};
